import React from 'react';

const Footer = () => (
    <footer className="footer">
        <div className="container">
            <p>&copy; {new Date().getFullYear()} Tiwari Minerals Company. All Rights Reserved.</p>
        </div>
    </footer>
);

export default Footer;